import { telemetryEnabled } from '@mygpt/app/config/integrations';
import './scripts/polyfills';
import './i18n';
import './assets/global.css';
import './assets/tailwind.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';

import * as Sentry from '@sentry/react';
import Cookies from 'js-cookie';
import mixpanel from 'mixpanel-browser';
import { Suspense } from 'react';
import * as ReactDOM from 'react-dom/client';
import { beforeSend, initEnv, initInstance, isSentryEligibleHostname } from '@mygpt/app';

import FallBack from '@/components/SuspenseFallBack';
import { COOKIE_KEY_MIXPANEL, MIXPANEL_TOKEN } from '@/constant';
import Provider from '@/provider';
import { AppRoutes } from '@/routes';
import './init.ts';

if (telemetryEnabled) mixpanel.init(MIXPANEL_TOKEN, { debug: true, ignore_dnt: true });

initEnv(import.meta.env.VITE_STAGE);
initInstance({
  isAdmin: true,
  baseUrl: window.ENV.GBASE_SUPPORT_FRONTEND_VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL,
  baseHost: import.meta.env.VITE_BASE_HOST || '',
});

// reset mixpanel distinct_id value (为了方便mixpanel后台查看)
const mixpanelCookieValue = Cookies.get(COOKIE_KEY_MIXPANEL);
if (telemetryEnabled && mixpanelCookieValue) {
  const newVal = JSON.parse(mixpanelCookieValue);
  newVal.distinct_id = 'gptbase';
  Cookies.set(COOKIE_KEY_MIXPANEL, JSON.stringify(newVal));
  mixpanel.track('visit', {
    url: window.location.href,
  });
}

const isPreOrProduction = ['pre', 'production', 'staging', 'onprem-main'].includes(import.meta.env.VITE_STAGE);
const isGptBaseDomain = isSentryEligibleHostname(window.location.hostname);

if (telemetryEnabled && isPreOrProduction && isGptBaseDomain) {
  Sentry.init({
    //@ts-ignore
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_STAGE,
    integrations: [Sentry.replayIntegration()],
    beforeSend,
    tracesSampleRate: 1.0,
    attachStacktrace: true,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider>
    <Suspense fallback={<FallBack />}>
      <AppRoutes />
    </Suspense>
  </Provider>
);
